import styled, {keyframes} from 'styled-components';
import {COLORS} from '../../../constants/colors';

const loading = keyframes`
   0%,
  100% {
    background-color: ${COLORS.Black};
    box-shadow:
      20px 0 0 ${COLORS.White},
      40px 0 0 ${COLORS.White};
  }
  33.3% {
    background-color: ${COLORS.White};
    box-shadow:
      20px 0 0 ${COLORS.Black},
      40px 0 0 ${COLORS.White};
  }
  66.6% {
    background-color: ${COLORS.White};
    box-shadow:
      20px 0 0 ${COLORS.White},
      40px 0 0 ${COLORS.Black};
  }
`;

export const AnimatedDots = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 18px;
  overflow: hidden;
  margin: 0 auto;

  ::after {
    content: '';
    display: block;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    margin-left: -40px;
    animation: ${loading} 2s infinite ease-out;
  }
`;
